import React, {FC} from 'react'

/** Public sayfaların yükleniyor / bulunamadı durumları */
export const PublicLoading: FC = () => (
  <div className='pc-page d-flex align-items-center justify-content-center'>
    <span className='spinner-border text-dark' role='status' />
  </div>
)

type NotFoundProps = {
  title: string
  description: string
}

export const PublicNotFound: FC<NotFoundProps> = ({title, description}) => (
  <div className='pc-page d-flex align-items-center justify-content-center'>
    <div className='text-center px-6'>
      <i className='bi bi-briefcase fs-3x text-gray-400 d-block mb-5'></i>
      <h1 className='fw-bolder text-gray-800 mb-3'>{title}</h1>
      <div className='text-muted fs-5'>{description}</div>
    </div>
  </div>
)
